export interface ApiEntry {
  name: string;
  endpoint: string;
  docs: string;
  usedFor: string;
  pages: Array<{ to: string; label: string }>;
  limits: string;
  fallback: string;
}

export const apiCatalog: ApiEntry[] = [
  {
    name: 'REST Countries',
    endpoint: 'https://restcountries.com/v3.1/all?fields=name,cca2,cca3,ccn3,region,population,area,flags,capital,independent',
    docs: 'https://restcountries.com',
    usedFor: 'Country names, ISO codes, population, flags, capitals',
    pages: [{ to: '/countries', label: 'Countries' }, { to: '/map', label: 'Map' }],
    limits: 'No key; no published rate limit',
    fallback: 'Embedded snapshot of ~70 countries',
  },
  {
    name: 'World Bank Indicators',
    endpoint: 'https://api.worldbank.org/v2/country/{code}/indicator/{indicator}?format=json&date=2020:2025',
    docs: 'https://datahelpdesk.worldbank.org/knowledgebase/articles/889392',
    usedFor: 'Internet users %, mobile subscriptions, working-age share, sex split, trends',
    pages: [{ to: '/countries', label: 'Countries' }, { to: '/map', label: 'Map' }],
    limits: 'No key; CORS enabled',
    fallback: 'Embedded indicator snapshot',
  },
  {
    name: 'OpenRouter models',
    endpoint: 'https://openrouter.ai/api/v1/models',
    docs: 'https://openrouter.ai/docs/api-reference/list-available-models',
    usedFor: 'Live routed-model catalog, free vs paid pricing, publisher → country',
    pages: [{ to: '/models', label: 'Models' }, { to: '/platforms?tab=models', label: 'Platforms' }],
    limits: 'No key for listing',
    fallback: 'Embedded sample of 24 models',
  },
  {
    name: 'Hugging Face Hub',
    endpoint: 'https://huggingface.co/api/models?sort=downloads&direction=-1&limit=50',
    docs: 'https://huggingface.co/docs/hub/api',
    usedFor: 'Most-downloaded open models',
    pages: [{ to: '/models', label: 'Models' }],
    limits: 'No key; anonymous rate limits apply',
    fallback: 'Embedded top-model snapshot',
  },
  {
    name: 'GitHub Search API',
    endpoint: 'https://api.github.com/search/repositories?q=created:>{today-7d}&sort=stars&order=desc&per_page=100',
    docs: 'https://docs.github.com/en/rest/search/search#search-repositories',
    usedFor: 'Top 100 new repos of the week',
    pages: [{ to: '/code', label: 'Code' }],
    limits: '10 searches/min unauthenticated',
    fallback: 'Embedded notable-repos snapshot',
  },
  {
    name: 'GitHub Repos API',
    endpoint: 'https://api.github.com/repos/{owner}/{repo}',
    docs: 'https://docs.github.com/en/rest/repos/repos#get-a-repository',
    usedFor: 'Live star counts for watched agent repos',
    pages: [{ to: '/code', label: 'Code' }],
    limits: '60 requests/hour per IP unauthenticated',
    fallback: '“unavailable” — no stale guess',
  },
  {
    name: 'APNIC Labs aspop',
    endpoint: 'https://stats.labs.apnic.net/aspop/{cca2}',
    docs: 'https://stats.labs.apnic.net/aspop',
    usedFor: 'Users per network (ASN) per country',
    pages: [{ to: '/countries/IND', label: 'Country pages' }, { to: '/networks', label: 'Networks' }],
    limits: 'No key; HTML table parsed client-side',
    fallback: 'Per-country top-5 snapshot (23 countries)',
  },
  {
    name: 'RIPEstat',
    endpoint: 'https://stat.ripe.net/data/country-asns/data.json?resource={cca2}',
    docs: 'https://stat.ripe.net/docs/data_api',
    usedFor: 'Full ASN registry link-out per country',
    pages: [{ to: '/countries/IND', label: 'Country pages' }],
    limits: 'No key',
    fallback: 'Link only',
  },
  {
    name: 'world-atlas TopoJSON',
    endpoint: 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json',
    docs: 'https://github.com/topojson/world-atlas',
    usedFor: 'Country shapes for the equal-area map',
    pages: [{ to: '/map', label: 'Map' }],
    limits: 'CDN',
    fallback: 'Map replaced with a link to the country table',
  },
];
